import { usePropsObject } from "@/lib/contexts/appContext"
import Blocks from "@/components/Blocks"
import TextImageBlock from "@/common/partials/textImageBlock/textImageBlock"

export default function ImageAndText({ block }) {
  const { attrs, innerBlocks } = block
  const object = usePropsObject()

  if (innerBlocks === undefined || innerBlocks.length === 0) {
    return null
  }

  const width = attrs?.width ?? "full"

  const blockSettings = {
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "core/list": { width: "bleed" },
    "theme/link": {
      width: "bleed",
      noLink: true,
      isButton: true
    }
  }

  return (
    <TextImageBlock
      block={block}
      link={attrs?.link}
      layout={attrs.layout}
      image={attrs.image}
      imageSize={attrs?.imageSize ?? null}
      hasPlate={attrs.theme !== "transparent"}
      plateColor={object?.theme?.plateColor || attrs.theme}
      padding={attrs.theme === "on-plate"}
      width={width}>
      <Blocks blocks={innerBlocks} settings={blockSettings} />
    </TextImageBlock>
  )
}
